import { Component, ElementRef, OnInit } from "@angular/core"
import { AngularFirestore } from "@angular/fire/firestore"
import { Router } from "@angular/router"
import { AuthService, DataService } from "@tr/services"

declare var $: any

@Component({
  selector: "tr-forbidden",
  templateUrl: "./forbidden.component.html",
})
export class ForbiddenComponent implements OnInit {
  public test: Date = new Date()
  private toggleButton
  private sidebarVisible: boolean
  private nativeElement: Node

  public uid: string
  public name: string
  public roles: string[]
  public testsRunCount: number
  public photoUrl: string
  public company: string

  constructor(
    private element: ElementRef,
    private router: Router,
    private dataService: DataService,
    private authService: AuthService,
    private afs: AngularFirestore,
  ) {
    this.nativeElement = element.nativeElement
    this.sidebarVisible = false

    this.name = ""
    this.roles = []
    this.testsRunCount = -1
    this.photoUrl = ""
  }

  public checkFullPageBackgroundImage(): void {
    const $page = $(".full-page")
    const imageSrc = $page.data("image")

    if (imageSrc !== undefined) {
      const imageContainer =
        '<div class="full-page-background" style="background-image: url(' +
        imageSrc +
        ') "/>'
      $page.append(imageContainer)
    }
  }

  public ngOnInit(): void {
    this.company = this.dataService.company.value
    this.uid = this.dataService.uid.value
    this.photoUrl = this.dataService.photoUrl.value

    this.loadData()

    this.checkFullPageBackgroundImage()

    const navbar: HTMLElement = this.element.nativeElement
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0]

    setTimeout(() => {
      // after 1000 ms we add the class animated to the login/register card
      $(".card").removeClass("card-hidden")
    }, 700)
  }
  public sidebarToggle(): void {
    const toggleButton = this.toggleButton
    const body = document.getElementsByTagName("body")[0]
    const sidebar = document.getElementsByClassName("navbar-collapse")[0]
    if (!this.sidebarVisible) {
      setTimeout(() => {
        toggleButton.classList.add("toggled")
      }, 500)
      body.classList.add("nav-open")
      this.sidebarVisible = true
    } else {
      this.toggleButton.classList.remove("toggled")
      this.sidebarVisible = false
      body.classList.remove("nav-open")
    }
  }

  public loadData(): void {
    if (this.company && this.uid) {
      const docRef = this.afs
        .collection("companies")
        .doc(this.company)
        .collection("users")
        .doc(this.uid)
      docRef.ref.get().then(doc => {
        if (doc.exists) {
          this.photoUrl = doc.data().photoUrl
        }
      })

      const docRefRoles = this.afs.collection("users").doc(this.uid)
      docRefRoles.ref.get().then(doc => {
        if (doc.exists) {
          this.roles = doc.data().roles
        }
      })
    }
  }

  public returnToDashboard(): void {
    if (this.roles.length === 0) {
      this.router.navigate(["pages/login"])
    }
    if (this.roles.includes("Admin")) {
      this.router.navigate(["dashboard"])
    } else if (
      this.roles.includes("Tester") ||
      this.roles.includes("PartnerTester")
    ) {
      this.router.navigate(["tester/dashboard"])
    } else if (
      this.roles.includes("Manager") ||
      this.roles.includes("PartnerManager") ||
      this.roles.includes("SeniorManager") ||
      this.roles.includes("PartnerSeniorManager")
    ) {
      this.router.navigate(["manager/dashboard"])
    } else if (this.roles.includes("SuperUser")) {
      this.router.navigate(["super/dashboard"])
    } else if (this.roles.includes("AccountManager")) {
      this.router.navigate(["account/dashboard"])
    } else {
      this.router.navigate(["pages/login"])
    }
  }
}
